export default "__VITE_ASSET__C6d563Yn__"